import axios from "axios";
import { configUrl } from "../../config";

const getTransactionData = async (userId) => {
    let response = await axios.get(
        `${configUrl.AssessmentServer}/api/UserSubscription/getTransactionDetails/${userId}`
    );
    let data = response.data;


    return data;
};

export default {
    getTransactionData: getTransactionData,
}